import * as S from './UserItem.styled';
import { Colors } from 'styles/variables/colors';

type OptionItemProps = {
    icon: React.FunctionComponent<
        React.SVGProps<SVGSVGElement> & {
            title?: string | undefined;
        }
    >;
    children: React.ReactNode;
    onClick?: () => void;
    margin?: string;
    svgMargin?: string;
};

const OptionItem = ({ icon, children, onClick, margin, svgMargin }: OptionItemProps) => {
    const Icon = icon;

    return (
        <S.MenuItem margin={margin} onClick={onClick}>
            <S.Item>
                <S.SvgContainer marginRight={svgMargin} fill={Colors.darkGray}>
                    <Icon />
                </S.SvgContainer>
                <S.Text>{children}</S.Text>
            </S.Item>
        </S.MenuItem>
    );
};

export default OptionItem;
